/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/guiJobInfos/guiJobInfosActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { GuiJobInfoEditForm } from "./GuiJobInfoEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { KTUtil } from "../../../../../../_metronic/_assets/js/components/util";
import KTLayoutQuickForm from "../../../../Admin/utils/quick-form";
import {GuideProfile} from "../../profile/GuideProfile";
import axios from "axios";

const initGuiJobInfo = {
  id: undefined,
  guideId: 0,
  companyName: "",
  jobTitle: "",
  jobType: "",
  startDate: "2020-10-17T04:43:24.265Z",
  endDate: "2020-10-17T04:43:24.265Z",
  expInYear: "",
  remark: "",
};
export function GuiJobInfoEdit({
  history,
  match: {
    params: { id,gid },
  },
}) {
  useLayoutEffect(() => {
    KTUtil.ready(function() {
      KTLayoutQuickForm.init("kt_quick_form");
    });
  }, []);
  // Subheader
  const subheader = useSubheader();

  // Tabs
  // const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, guiJobInfoForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.guiJobInfos.actionsLoading,
      guiJobInfoForEdit: state.guiJobInfos.guiJobInfoForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchGuiJobInfo(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Guide JobInfo";
    if (guiJobInfoForEdit && id) {
      _title = `Edit Guide JobInfo '`;
    }

    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guiJobInfoForEdit, id]);

  const saveGuiJobInfo = (values) => {
    if (!id) {
      dispatch(actions.createGuiJobInfo(values)).then(() =>
        backToGuiJobInfosList()
      );
    } else {
      dispatch(actions.updateGuiJobInfo(values)).then(() =>
        backToGuiJobInfosList()
      );
    }
  };

  const btnRef = useRef();
  const saveGuiJobInfoClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };
  const id1 = id===undefined?'':id
  const GuideUrl = `${process.env.REACT_APP_API_URL}/api/guiJobInfo/${id1}`;

  const [guide, setGuide] = useState([]);

  useEffect(() => {
    const getGuide = async () => {
      const response = await axios.get(GuideUrl);
      setGuide(response.data);
    };
    getGuide();
  }, [setGuide,GuideUrl]);


  const GuideId = gid?gid:guide.guideId;
 
 
 
  initGuiJobInfo.guideId=GuideId;
  console.log(GuideId)

  const backToGuiJobInfosList = () => {
    history.push(`/guide/guideprofile`);
  };

  return (
    <div>
      <GuideProfile />
      <div
        id="kt_quick_form"
        className="offcanvas offcanvas-right offcanvas offcanvas-on offcanvas-sm"
      >
        <div className="offcanvas-content pr-5 mr-n5">
          <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}>
              <CardHeaderToolbar>
                <button
                  type="button"
                  onClick={backToGuiJobInfosList}
                  className="btn btn-light"
                >
                  <i className="fa fa-times"></i>
                  Close
                </button>
                {/* <button className="btn btn-light ml-2">
                    <i className="fa fa-redo"></i>
                    Reset
                  </button> */}
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  onClick={saveGuiJobInfoClick}
                >
                  Save
                </button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              {!actionsLoading && (
                <GuiJobInfoEditForm
                  actionsLoading={actionsLoading}
                  guiJobInfo={guiJobInfoForEdit || initGuiJobInfo}
                  btnRef={btnRef}
                  saveGuiJobInfo={saveGuiJobInfo}
                />
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
